import { render, staticRenderFns } from "./PedidosLista.vue?vue&type=template&id=fb31812e"
import script from "./PedidosLista.vue?vue&type=script&lang=js"
export * from "./PedidosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports